import { render } from "./VueModalPopUp.vue?vue&type=template&id=41452db0&scoped=true&ts=true"
import script from "./VueModalPopUp.vue?vue&type=script&lang=ts"
export * from "./VueModalPopUp.vue?vue&type=script&lang=ts"

import "./VueModalPopUp.vue?vue&type=style&index=0&id=41452db0&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41452db0"]])

export default __exports__